
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/wallet-extension",
      function () {
        return require("private-next-pages/products/wallet-extension.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/wallet-extension"])
      });
    }
  